import Footer from "../components/footer/footer"
import Hero from "../components/apply/hero"
import Awareness from "../components/apply/awareness";
import Process from "../components/apply/process";
import Formulary from "../components/apply/formulary";

export default function ApplyTo(){
    return(
        <>
        <Hero />
        <Awareness />
        <Process />
        <Formulary />
        <Footer />
        </>
    );
}